PJQ.views.settings.AddressBookGeneralSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Address-Book-General'),
		onChange: null
	},
	beforeFirstRender: function () {
		this.listenTo(this.model, 'fetch', this.render);
	},
	beforeRender: function () {
		this.showLaborStatus = PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.IS_HIDE_UNION_STATUS) !== true;
		this.groupLabel = PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) : "Trades";
		this.renderData = {
			model: this.model,
			groupLabel: this.groupLabel,
			newAddressBook: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_ADDRESSBOOK),
			showLaborStatus: this.showLaborStatus
		};
	},
	afterRender: function () {
		if (!PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.ENABLE_NEW_ADDRESSBOOK)) {
			new PJQ.inputs.Selectpicker({
				el: this.$('.select-company-default-view'),
				defaultValue: (_.size(this.model.get('companyDefaultView')) > 0) ? this.model.get('companyDefaultView') : "view_group",
				onChange: _.bind(function (value) {
					this.model.set('companyDefaultView', value);
					this.onChange();
				}, this)
			});

			new PJQ.inputs.Selectpicker({
				el: this.$('.select-default-view'),
				defaultValue: (_.size(this.model.get('defaultView')) > 0) ? this.model.get('defaultView') : "view_group",
				onChange: _.bind(function (value) {
					this.model.set('defaultView', value);
					this.onChange();
				}, this)
			});
		}

		let defaultFilters = _.map(PJQ.app.session.userTypes.getByIsCompany(false), function (userType) {
			return userType.get('userTypeId');
		});
		$.merge(defaultFilters, [PJQ.constants.addressBook.directoryFilter.PRIVATE_ONLY, PJQ.constants.addressBook.contactStatusFilter.ACTIVE, PJQ.constants.addressBook.contactStatusFilter.INACTIVE]);
		if (this.showLaborStatus)
			$.merge(defaultFilters, [PJQ.constants.addressBook.laborStatusFilter.UNION, PJQ.constants.addressBook.laborStatusFilter.NON_UNION, PJQ.constants.addressBook.laborStatusFilter.PREV_WAGE, PJQ.constants.addressBook.laborStatusFilter.NOT_AVAILABLE]);
		this.filterSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-default-filter'),
			isIntChoices: true,
			isMultiple: true,
			exclusiveChoices: [-3, -4],
			isGroup: true,
			mustSelectValuePerOptGroup: true,
			defaultValue: this.model.get('defaultFilters').length > 0 ? this.model.get('defaultFilters').split(',') : defaultFilters,
			onChange: _.bind(function (value) {
				this.model.set('defaultFilters', value.join())
				this.onChange();
			}, this)
		});

		this.locationTypeSelectPicker = new PJQ.inputs.Selectpicker({
			el: this.$('.select-default-location-type'),
			isIntChoices: true,
			isMultiple: true,
			mustSelectValue: true,
			defaultValue: this.model.get('defaultLocationFilters').length > 0 ? this.model.get('defaultLocationFilters').split(',') : [PJQ.constants.addressBook.locationTypeFilter.WORK_AREA, PJQ.constants.addressBook.locationTypeFilter.OFFICE_LOCATION],
			onChange: _.bind(function (value) {
				this.model.set('defaultLocationFilters', value.join())
				this.onChange();
			}, this)
		});

		new PJQ.inputs.Selectpicker({
			el: this.$('.select-rows-per-page'),
			defaultValue: this.model.get('rowsPerPage'),
			onChange: _.bind(function (value) {
				this.model.set('rowsPerPage', value);
				this.onChange();
			}, this)
		});

		$(function () {
			$('[data-toggle="tooltip"]').tooltip()
		});
		new PJQ.Binder(this.$el, this.model, {
			setDefaultValues: true,
			watchElements: [
				'input'
			],
			afterChange: _.bind(function () {
				this.onChange();
			}, this)
		});
	},
	onChange: function () {
		if (typeof this.options.onChange === 'function') {
			this.options.onChange(this.model);
		}
	}
});

PJQ.views.settings.ContactFieldSettings = PJQ.views.BaseView.extend({
	defaults: {
		template: new PJQ.templating.Template(PJQ.constants.modules.SETTINGS, 'Contact-Core-Fields')
	},
	events: {
		'click .cb-visible-contact': 'contactVisibleChanged',
		'click .cb-visible-admin': 'adminVisibleChanged',
		'click .cb-required-contact': 'contactRequiredChanged',
		'click .cb-required-admin': 'adminRequiredChanged'
	},
	beforeFirstRender: function () {
		PJQ.app.session.fetchContactFieldSettings(null, _.bind(function (fields) {
			this.collection = fields;

			let fillFields = [
				{
					fieldName: "active",
					name: "Active",
					canContactEdit: false,
					isVisibleContact: false,
					isRequiredContact: false,
					isRequiredAdmin: false,
					canBeRequired: false
				},
				{
					fieldName: "companyName",
					name: "Company Name"
				},
				{
					fieldName: "laborStatus",
					name: "Labor Status"
				},
				{
					fieldName: "classifications",
					name: "Certifications",
					isRequiredContact: false,
					isRequiredAdmin: false
				},
				{
					fieldName: "sector",
					name: "Sector"
				},
				{
					fieldName: "companyNotes",
					name: "Company Notes",
					canContactEdit: false,
					isVisibleContact: false,
					isRequiredContact: false
				},
				{
					fieldName: "contactName",
					name: "Contact Name"
				},
				{
					fieldName: "title",
					name: "Title"
				},
				{
					fieldName: "address1",
					name: "Address 1"
				},
				{
					fieldName: "address2",
					name: "Address 2"
				},
				{
					fieldName: "city",
					name: "City"
				},
				{
					fieldName: "state",
					name: "State"
				},
				{
					fieldName: "zip",
					name: "Postal Code"
				},
				{
					fieldName: "country",
					name: "Country"
				},
				{
					fieldName: "phone",
					name: "Phone"
				},
				{
					fieldName: "cell",
					name: "Cell"
				},
				{
					fieldName: "fax",
					name: "Fax"
				},
				{
					fieldName: "email",
					name: "Email"
				},
				{
					fieldName: "contactNotes",
					name: "Contact Notes",
					canContactEdit: false,
					isVisibleContact: false,
					isRequiredContact: false
				},
				{
					fieldName: "groups",
					name: PJQ.app.session.preferences.hasPref(PJQ.constants.preferenceTypes.GROUP_LABEL) ? PJQ.app.session.preferences.getPref(PJQ.constants.preferenceTypes.GROUP_LABEL) : "Groups"
				},
				{
					fieldName: "workAreas",
					name: "Work Areas"
				}
			];

			_.each(fillFields, _.bind(function (field, index) {
				let matchField = this.collection.findWhere({fieldName: field.fieldName});
				if (matchField == null) {
					this.collection.add(_.defaults(field, {
						isVisibleContact: true,
						isVisibleAdmin: true,
						isRequiredContact: false,
						isRequiredAdmin: false,
						sortOrder: index,
						canContactEdit: field.canContactEdit !== false
					}));
				}
				else {
					matchField.set({
						name: field.name,
						sortOrder: index,
						canContactEdit: field.canContactEdit !== false
					});
				}
			}, this));

			this.render();
		}, this));
	},
	afterRender: function () {
		if (this.collection == null || !this.collection.isFetched) {
			return;
		}

		this.dataTable = new PJQ.views.dataTables.DataTable({
			el: this.$(".field-table"),
			data: this.collection.models,
			isHideSearch: true,
			paging: false,
			rowId: "cid",
			order: [0, 'asc'],
			columns: [
				{
					"title": "",
					"data": "attributes.sortOrder",
					"visible": false
				},
				{
					"title": "Name",
					"data": "attributes.name",
					"orderable": false
				},
				{
					"title": "Visible To Contact",
					"data": "attributes.isVisibleContact",
					"orderable": false,
					"render": function (data, type, row) {
						let contactEdit = row.get('canContactEdit') !== false;
						return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-visible-contact"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
					}
				},
				{
					"title": "Required for Contact",
					"data": "attributes.isRequiredContact",
					"orderable": false,
					"render": function (data, type, row) {
						if (row.get('canBeRequired') === false) {
							return '<div class="pretty p-switch" title="This field can not be required"><input disabled type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-contact"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
						}
						let contactEdit = row.get('canContactEdit') !== false;
						return '<div class="pretty p-switch" ' + (contactEdit ? '' : 'title="This field is never visible to contacts"') + '><input ' + (contactEdit ? '' : 'disabled') + ' type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-contact"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
					}
				},
				{
					"title": "Visible To Admin",
					"data": "attributes.isVisibleAdmin",
					"orderable": false,
					"render": function (data) {
						return '<div class="pretty p-switch"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-visible-admin"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>'
					}
				},
				{
					"title": "Required for Admin",
					"data": "attributes.isRequiredAdmin",
					"orderable": false,
					"render": function (data, type, row) {
						if (row.get('canBeRequired') === false) {
							return '<div class="pretty p-switch" title="This field can not be required"><input disabled type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-admin"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>';
						}
						return '<div class="pretty p-switch"><input type="checkbox" ' + (data ? 'checked' : '') + ' class="cb-required-admin"><div class="state p-primary"><label><span class="fs-16">&nbsp;</span></label></div></div>'
					}
				}
			]
		});
	},
	contactVisibleChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data(),
			enabled = $target.prop('checked');
		setting.set('isVisibleContact', enabled);

		if (enabled) {
			// if the field is made visible to contacts, it must be visible to admins too
			setting.set('isVisibleAdmin', true);
		}
		else {
			// if the field is made invisible to contacts
			// it must be made not required for contacts
			setting.set('isRequiredContact', false);
			setting.set({
				isRequiredContact: false
			});
		}

		setting.queueSave();
		this.dataTable.refresh();
	},
	adminVisibleChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data(),
			enabled = $target.prop('checked');
		setting.set('isVisibleAdmin', enabled);

		if (!enabled) {
			// if the field is made invisible to admins
			// it must be made not required for admins
			// it must also be made not visible and not required for contacts
			setting.set({
				isVisibleContact: false,
				isRequiredContact: false,
				isRequiredAdmin: false
			});
			this.dataTable.refresh();
		}

		setting.queueSave();
	},
	contactRequiredChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data();
		setting.set('isRequiredContact', $target.prop('checked'));
		setting.queueSave();
	},
	adminRequiredChanged: function (e) {
		let $target = $(e.currentTarget),
			$row = $target.closest('tr'),
			row = this.dataTable.getRow($row),
			setting = row.data();
		setting.set('isRequiredAdmin', $target.prop('checked'));
		setting.queueSave();
	}
});
